<template>
  <div class="col-12">
    <div class="card mb-5 " style="margin-top: 4rem; overflow: visible">
      <div
        class="card-header p-0 position-relative mt-n4 mx-3 z-index-2"
        style="height: 60px;"
      >
        <div
          class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100"
        >
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ $t('students.addNewTitle') }}
            </h6>
          </div>
        </div>
      </div>

      <div class="card-body px-0 pb-2">
        <div class="row justify-content-center">
          <div class="col-12">
            <StudentForm
              ref="studentForm"
              :title="$t('students.addNewTitle')"
              :submit-text="$t('students.addButton')"
              @submit="handleSubmit"
              @cancel="handleCancel"
              @validation-error="handleValidationError"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import StudentForm from '@/components/features/students/forms/StudentForm.vue';
import { useToast } from 'vue-toastification';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const toast = useToast();
const router = useRouter();
const store = useStore();
const studentForm = ref(null);
const isSubmitting = ref(false);

const handleSubmit = async (formData) => {
  isSubmitting.value = true;
  try {
    const response = await store.dispatch('students/createStudent', formData);
    const createdStudent = response.data;

    console.log('Created Student Image URL:', createdStudent.image_url);

    toast.success(t('students.addSuccess'));
    router.push('/students');
  } catch (error) {
    console.error('Error adding student:', error);
  } finally {
    isSubmitting.value = false;
  }
};

const handleValidationError = () => {
  toast.warning(t('students.validationError'));
};

const handleCancel = () => {
  if (!isSubmitting.value) {
    router.push('/students');
  }
};
</script>
